import { useContext } from "react";
import { Divider, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { ArrangeHorizontal } from "iconsax-react";
import { LocaleContext } from "../../../../routing/LangRouter";
import { useTranslation } from "react-i18next";

//import general components
import { BaseButton } from "../../../common/base-button/base-button";

//import styles
import "./replace-item.scss";

function ReplaceItem({ replaceItem, selectedItem, handleRadioChange, handleReplaceItem, checkedFreeTime }) {
    //general
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    return (
        <Grid
            className={`replace-item ${selectedItem === replaceItem.global_id ? "select" : ""}`}
            container
            item
            xs={12}
            md={11.5}
            rowGap={2}
            justifyContent="space-between"
        >
            <Grid
                className="replace-item__details"
                container
                item
                xs="auto"
                display={{ xs: "none", md: "flex" }}
                justifyContent="center"
                alignItems="center"
            >
                <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={selectedItem}
                    onChange={event => handleRadioChange(event)}
                >
                    <FormControlLabel
                        value={replaceItem.global_id}
                        control={
                            <Radio
                                sx={{
                                    color: "var(--primary-color)",
                                    "&.Mui-checked": {
                                        color: "var(--primary-color)",
                                    },
                                }}
                            />
                        }
                        label=""
                        disabled={checkedFreeTime}
                    />
                </RadioGroup>
            </Grid>

            <Grid
                className="replace-item__image-details"
                container
                item
                xs={12}
                md={2}
                justifyContent="center"
                alignItems={{ xs: "stretch", md: "center" }}
                sx={{ backgroundImage: { xs: `url(${"https://api.atripa.com" + replaceItem.image})`, md: "none" } }}
            >
                <img className="replace-item__image" src={"https://api.atripa.com" + replaceItem.image} />

                <Grid
                    className="replace-item__description"
                    container
                    item
                    xs={12}
                    display={{ xs: "flex", md: "none" }}
                    justifyContent="space-between"
                    alignItems="flex-start"
                >
                    <span className="replace-item__category">{locale === "en" ? replaceItem.category : replaceItem.category_persian}</span>
                </Grid>

                <Grid
                    className="replace-item__text"
                    container
                    item
                    xs={12}
                    display={{ xs: "flex", md: "none" }}
                    justifyContent="space-between"
                    alignItems="flex-end"
                >
                    <span>{locale === "en" ? replaceItem.name1 : replaceItem.name2}</span>
                    <span>
                        {" "}
                        {replaceItem.start_time.substr(0, 2) + ":" + replaceItem.start_time.substr(2, 2)} -{" "}
                        {replaceItem.end_time.substr(0, 2) + ":" + replaceItem.end_time.substr(2, 2)}
                    </span>
                </Grid>
            </Grid>

            <Grid className="replace-item__details" container item xs={12} md={7.5} rowGap={1}>
                <Grid container item xs={12} display={{ xs: "none", md: "flex" }} alignItems="center">
                    <span>{locale === "en" ? replaceItem.name1 : replaceItem.name2}</span>
                    <span className="replace-item__category">{locale === "en" ? replaceItem.category : replaceItem.category_persian}</span>
                </Grid>

                <Grid container item xs={8} display={{ xs: "none", md: "flex" }} justifyContent="space-between" alignItems="center">
                    <span>
                        {t("start")}: {replaceItem.start_time.substr(0, 2) + ":" + replaceItem.start_time.substr(2, 2)}
                    </span>
                    <Grid container item xs={3}>
                        <Divider width="100%" sx={{ borderBottomColor: "var(--teal-color-18)" }} />
                    </Grid>
                    <span>
                        {t("end")}: {replaceItem.end_time.substr(0, 2) + ":" + replaceItem.end_time.substr(2, 2)}
                    </span>
                </Grid>

                <Grid container item xs={12}>
                    <Grid className="replace-item__distance" container item xs={6}>
                        <span>{t("distanceP")}:</span>
                        <span className="replace-item__distance-value">
                            {replaceItem.navigation_time_mins} {t("minutes")}
                        </span>
                    </Grid>
                    <Grid className="replace-item__distance" container item xs={6} justifyContent={{ xs: "flex-end", md: "flex-start" }}>
                        <span>{t("distanceN")}:</span>
                        <span className="replace-item__distance-value">
                            {replaceItem.navigation_time_minsC} {t("minutes")}
                        </span>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container item xs={12} display={{ xs: "flex", md: "none" }}>
                <BaseButton
                    text={t("replace")}
                    color="primary"
                    size="medium"
                    radius="radius-10"
                    rightIcon={<ArrangeHorizontal size="24" color="var(--light-color)" variant="Outline" />}
                    type="submit"
                    handleClick={() => handleReplaceItem(replaceItem.global_id)}
                    disabled={checkedFreeTime}
                />
            </Grid>
        </Grid>
    );
}

export default ReplaceItem;
